<template>
  <div class="cyberpunk-refund-analysis">
    <!-- 数字雨背景效果 -->
    <div class="matrix-rain" ref="matrixCanvas">
      <canvas></canvas>
    </div>

    <!-- 全息网格背景 -->
    <div class="holo-grid"></div>

    <!-- 扫描线效果 -->
    <div class="scanlines"></div>

    <!-- 粒子效果 -->
    <div class="particles" ref="particles"></div>

    <!-- 主要布局 -->
    <div class="main-layout">
      <!-- 左侧图表区 -->
      <div class="charts-area">
        <!-- 控制面板 -->
        <div class="control-panel glass-panel">
          <h3 class="panel-title">
            <i class="el-icon-setting cyber-icon-style"></i>
            控制中心
          </h3>
          <div class="control-grid">
            <!-- <div class="control-item">
              <label class="control-label">地区选择</label>
              <el-select class="mineSelect" v-model="region" placeholder="请选择">
                <el-option v-for="item in countryList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div> -->
            <div class="control-item">
              <label class="control-label">景区选择</label>
              <SearchSelect
                class="mineSelect"
                v-model="reqForm.storeIdList"
                :options="storeOptions"
                :props="{
                  label: 'label',
                  value: 'value',
                }"
                placeholder="请选择景区"
              />
            </div>

            <div class="control-item">
              <label class="control-label">设备类型</label>
              <el-select
                class="mineSelect"
                v-model="category"
                placeholder="请选择"
                multiple
                filterable
                clearable
                v-collapse-tags="2"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>

            <div class="control-item">
              <label class="control-label">时间范围</label>
              <el-date-picker
                v-model="reqForm.timeRange"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions"
                :clearable="false"
                class="cyber-date-picker"
              />
            </div>

            <div class="control-item">
              <label class="control-label" style="visibility: hidden"
                >占位</label
              >
              <button
                @click="handleQuery"
                class="cyber-button"
                :loading="tableLoading"
              >
                <span class="button-text">查询</span>
                <div class="button-glow"></div>
              </button>
            </div>
          </div>
        </div>

        <!-- 核心统计卡片 -->
        <div class="stats-row">
          <div class="stat-card glass-panel primary">
            <div class="stat-header">
              <span class="stat-title">订单总数</span>
              <i class="el-icon-shopping-cart-2 cyber-icon-style"></i>
            </div>
            <div class="stat-value" ref="totalOrdersValue">
              {{ formatNumber(summary.total_orders) }}
            </div>
            <div class="stat-trend">
              <i class="el-icon-top-right cyber-icon-style"></i>
              <span class="trend-text">截止至昨日</span>
            </div>
            <div class="stat-glow"></div>
          </div>

          <!-- <div class="stat-card glass-panel warning">
            <div class="stat-header">
              <span class="stat-title">退款订单</span>
              <i class="el-icon-refresh-left cyber-icon-style"></i>
            </div>
            <div class="stat-value" ref="refundOrdersValue">
            {{ formatNumber(summary.refund_total_orders) }}
          </div>
            <div class="stat-trend">
              <span class="trend-icon">⚠️</span>
              <span class="trend-text">需关注</span>
        </div>
            <div class="stat-glow"></div>
          </div> -->

          <!-- <div class="stat-card glass-panel danger">
            <div class="stat-header">
              <span class="stat-title">退款次数</span>
              <span class="stat-icon">🔢</span>
            </div>
            <div class="stat-value" ref="refundCountValue">
            {{ formatNumber(summary.refund_total_refund_num) }}
          </div>
                        <div class="stat-trend">
              <i class="el-icon-data-analysis cyber-icon-style"></i>
              <span class="trend-text">累计统计</span>
            </div>
            <div class="stat-glow"></div>
          </div> -->

          <div class="stat-card glass-panel success">
            <div class="stat-header">
              <span class="stat-title">故障率</span>
              <i class="el-icon-bottom-left cyber-icon-style"></i>
            </div>
            <div class="stat-value" ref="refundRateValue">
              {{
                summary.total_orders > 0
                  ? ((unshippedCount / summary.total_orders) * 100).toFixed(2)
                  : "0.00"
              }}%
            </div>
            <div class="stat-trend">
              <i class="el-icon-aim cyber-icon-style"></i>
              <span class="trend-text">关键指标</span>
            </div>
            <div class="stat-glow"></div>
          </div>
        </div>

        <!-- 退款原因分布图 和 明细并排容器 -->
        <div class="dual-reason">
          <!-- 退款原因分布图 -->
          <div class="chart-container">
            <div class="chart-header">
              <h3 class="chart-title">
                <i class="el-icon-data-board cyber-icon-style"></i>
                退款原因分析
              </h3>
              <button @click="showReasonDetail" class="cyber-button-small">
                <i class="el-icon-download"></i>
                <span>导出</span>
              </button>
            </div>
            <div class="chart-content" ref="refundReasonChart"></div>
          </div>

          <!-- 退款原因分析（列表） -->
          <div class="chart-container">
            <div class="chart-header">
              <h3 class="chart-title">
                <i class="el-icon-document cyber-icon-style"></i>
                退款原因分析（设备明细）
              </h3>
              <div class="chart-controls">
                <button
                  @click="refreshTrendDetailChart"
                  class="cyber-button-small"
                >
                  <i class="el-icon-refresh-left"></i>
                  <span>刷新</span>
                </button>
                <button
                  @click="showReasonDetail_device(1)"
                  class="cyber-button-small"
                >
                  <i class="el-icon-download"></i>
                  <span>导出</span>
                </button>
                <button
                  @click="showReasonDetail_device(2)"
                  class="cyber-button-small"
                >
                  <i class="el-icon-download"></i>
                  <span>导出退款日志</span>
                </button>
              </div>
            </div>
            <div class="chart-hint" v-if="currentReason">
              <i class="el-icon-info-filled cyber-icon-style"></i>
              <span class="hint-text">当前筛选：{{ currentReason }}</span>
            </div>
            <div class="chart-hint" v-else>
              <i class="el-icon-info-filled cyber-icon-style"></i>
              <span class="hint-text"
                >想深入了解某一退款原因吗？试试点击左侧玫瑰图的花瓣吧！</span
              >
            </div>
            <div class="chart-content">
              <div class="reason-detail-list">
                <div
                  v-for="(item, index) in refundReasonDetailList"
                  :key="index"
                  class="reason-detail-item"
                >
                  <!-- 排名标识 -->
                  <div
                    v-if="index < 3"
                    class="reason-rank-badge"
                    :class="`reason-rank-${index + 1}`"
                  >
                    No.{{ index + 1 }}
                  </div>
                  <div
                    v-else-if="index < 50"
                    class="reason-rank-badge reason-rank-4-50"
                  >
                    No.{{ index + 1 }}
                  </div>
                  <div v-else class="reason-rank-badge reason-rank-50-plus">
                    No.{{ index + 1 }}
                  </div>

                  <!-- 内容区域 -->
                  <div class="reason-item-content">
                    <!-- 设备名称 -->
                    <div class="reason-device-name">
                      {{ item.device_name }}
                    </div>

                    <!-- 进度条 -->
                    <div class="reason-progress-bar-container">
                      <div
                        class="reason-progress-bar"
                        :style="{
                          width: (item.count / maxReasonCount) * 100 + '%',
                        }"
                      ></div>
                    </div>
                  </div>

                  <!-- 数值 -->
                  <div class="reason-count">{{ item.count }}次</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 订单状态分析图 和 明细并排容器 -->
        <div class="dual-status">
          <!-- 订单状态分析图 -->
          <div class="chart-container">
            <div class="chart-header">
              <h3 class="chart-title">
                <i class="el-icon-shopping-cart-2 cyber-icon-style"></i>
                订单出货状态
              </h3>
              <button @click="showStatusDetail" class="cyber-button-small">
                <i class="el-icon-download"></i>
                <span>导出</span>
              </button>
            </div>
            <div class="chart-content" ref="orderStatusChart"></div>
          </div>

          <!-- 订单状态分析（明细） -->
          <div class="chart-container">
            <div class="chart-header">
              <h3 class="chart-title">
                <i class="el-icon-data-analysis cyber-icon-style"></i>
                订单状态分析（设备明细）
              </h3>
              <div class="chart-controls">
                <button
                  @click="refreshOrderStatusDetailChart"
                  class="cyber-button-small"
                >
                  <i class="el-icon-refresh-left"></i>
                  <span>刷新</span>
                </button>
                <button
                  @click="showStatusDetail_device"
                  class="cyber-button-small"
                >
                  <i class="el-icon-download"></i>
                  <span>导出</span>
                </button>
              </div>
            </div>
            <div class="chart-hint" v-if="currentStatus">
              <i class="el-icon-info-filled cyber-icon-style"></i>
              <span class="hint-text">当前筛选：{{ currentStatus }}</span>
            </div>
            <div class="chart-hint" v-else>
              <i class="el-icon-info-filled cyber-icon-style"></i>
              <span class="hint-text"
                >想深入了解某一退款状态吗？试试点击左侧玫瑰图的花瓣吧！</span
              >
            </div>
            <div class="chart-content">
              <div class="status-detail-list">
                <div
                  v-for="(item, index) in orderStatusDetailList"
                  :key="index"
                  class="status-detail-item"
                >
                  <!-- 排名标识 -->
                  <div
                    v-if="index < 3"
                    class="rank-badge"
                    :class="`rank-${index + 1}`"
                  >
                    No.{{ index + 1 }}
                  </div>
                  <div v-else-if="index < 50" class="rank-badge rank-4-50">
                    No.{{ index + 1 }}
                  </div>
                  <div v-else class="rank-badge rank-50-plus">
                    No.{{ index + 1 }}
                  </div>

                  <!-- 内容区域 -->
                  <div class="item-content">
                    <!-- 设备名称 -->
                    <div class="device-name">
                      {{ item.device_name }}
                    </div>

                    <!-- 进度条 -->
                    <div class="progress-bar-container">
                      <div
                        class="progress-bar"
                        :style="{
                          width: (item.count / maxStatusCount) * 100 + '%',
                        }"
                      ></div>
                    </div>
                  </div>

                  <!-- 数值 -->
                  <div class="status-count">{{ item.count }}次</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 景区排行榜 -->
        <div class="chart-container glass-panel full-width">
          <div class="chart-header">
            <h3 class="chart-title">
              <i class="el-icon-trophy cyber-icon-style"></i>
              景区退款分析排行榜
            </h3>
            <button @click="refreshTrendChart" class="cyber-button-small">
              <span>刷新</span>
            </button>
          </div>
          <div class="chart-content ranking-chart" ref="refundTrendChart"></div>
        </div>

        <!-- 数据表格 -->
        <div class="data-table glass-panel full-width">
          <div class="table-header">
            <h2 class="chart-title">
              <i class="el-icon-document-copy cyber-icon-style"></i>
              景区退款详细分析
            </h2>
            <button @click="downloadTable" class="cyber-button">
              <i class="el-icon-download"></i>
              <span class="button-text">导出数据</span>
              <div class="button-glow"></div>
            </button>
          </div>

          <div class="table-container">
            <el-table
              :data="currentPageData"
              border
              max-height="600"
              v-loading="tableLoading"
              @sort-change="handleSortChange"
              :default-sort="{ prop: 'refund_num_sum', order: 'descending' }"
            >
              <el-table-column
                prop="company_name"
                label="景区名称"
                min-width="220"
                align="center"
              />
              <el-table-column
                prop="store_name"
                label="ERP仓库名称"
                min-width="220"
                align="center"
              />
              <el-table-column
                prop="refund_num_sum"
                label="退款订单数"
                min-width="130"
                align="center"
                sortable="custom"
              />
              <el-table-column
                prop="record_count"
                label="退款次数"
                min-width="130"
                align="center"
                sortable="custom"
              />
              <el-table-column
                prop="refund_rate"
                label="退款率"
                min-width="100"
                align="center"
                sortable="custom"
              >
                <template slot-scope="scope">
                  <div class="bar-cell rate">
                    <div
                      class="bar-fill bar-rate"
                      :style="{
                        width:
                          (Number(scope.row.refund_rate || 0) * 100).toFixed(
                            2
                          ) + '%',
                      }"
                    ></div>
                    <span class="bar-text"
                      >{{
                        (Number(scope.row.refund_rate || 0) * 100).toFixed(2)
                      }}%</span
                    >
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="is_auto_1_count"
                label="自动退款订单数"
                min-width="150"
                align="center"
                sortable="custom"
              />
              <el-table-column
                prop="is_auto_0_count"
                label="手动退款订单数"
                min-width="150"
                align="center"
                sortable="custom"
              />
            </el-table>

            <!-- 分页组件 -->
            <div class="pagination-container">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="refund_list.length"
                background
                class="cyber-pagination"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SearchSelect from "@/views/components/SearchSelect";
import {
  getRefundAnalysis,
  getRefundAnalysisDownload,
  getRefundAnalysisDownloadTwo,
  getRefundAnalysisDownloadThree,
  getRefundAnalysisReason,
  getRefundAnalysisStatus,
  getRefundAnalysisDevices,
  getRefundAnalysisDownloadStatus,
  getRefundAnalysisDownloadReason,
} from "@/api/bi";
import { getrefundLogDownload } from "@/api/order";
import * as echarts from "echarts";
import "@fontsource/orbitron/400.css";
import "@fontsource/orbitron/700.css";
import "@fontsource/orbitron/900.css";
import "@fontsource/rajdhani/300.css";
import "@fontsource/rajdhani/400.css";
import "@fontsource/rajdhani/600.css";
import "@fontsource/rajdhani/700.css";

export default {
  name: "CyberpunkRefundAnalysis",
  components: {
    SearchSelect,
  },
  props: ["allStore"],
  data() {
    return {
      region: '0', // 国家
      countryList: [
        { value: '0', label: '全部' },
        { value: '1', label: '中国大陆' },
        { value: '2', label: '中国香港' },
        { value: '3', label: '中国澳门' },
        { value: '4', label: '中国台湾' },
        { value: '5', label: '阿联酋' },
        { value: '6', label: '美国' },
        { value: '7', label: '韩国' },
      ],
      // 表格内进度条用到的最大值（渲染后计算）
      maxRefundOrders: 1,
      maxRecordCount: 1,
      maxAutoCount: 1,
      maxManualCount: 1,
      reqForm: {
        storeIdList: [],
        deviceIdList: [],
        goodsName: "",
        page: 0,
        pageSize: 0,
        timeRange: [],
        storeId: [],
      },
      reason: "11",
      status: "",
      category: ["1", "2", "3", "4", "5", "6", "7", "8"],
      options: [
        { value: "1", label: "771/772" },
        { value: "2", label: "775" },
        { value: "3", label: "776" },
        { value: "4", label: "779" },
        { value: "5", label: "780" },
        { value: "6", label: "781" },
        { value: "7", label: "782" },
        { value: "8", label: "783" },
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
        disabledDate(time) {
          // time.getTime() > 今天零点时间戳 → 禁用
          const todayZero = new Date(new Date().toLocaleDateString()).getTime();
          return time.getTime() >= todayZero;
        }
      },
      order_status_analysis: [],
      refund_list: [],
      refund_reason_analysis: [],
      refund_trend_analysis: [], // 退款原因货道详情分析详情
      order_status_detail: [], // 订单状态详情分析
      currentReason: "", // 当前筛选的退款原因
      currentStatus: "", // 当前筛选的订单状态
      summary: {},

      currentPage: 1,
      pageSize: 20,
      tableLoading: false,
      sortBy: "",
      sortOrder: "",
      refundReasonChart: null,
      orderStatusChart: null,
      refundTrendChart: null,
      refundTrendDetailChart: null,
      orderStatusDetailChart: null,
      currentTime: new Date().toLocaleTimeString(),
      orderStatusDetailList: [],
      maxStatusCount: 1,
      refundReasonDetailList: [],
      maxReasonCount: 1,
      timeInterval: null,
      systemStatus: {
        cpu: 23,
        memory: 67,
      },
      // 特效相关
      matrixInterval: null,
      particleInterval: null,
    };
  },
  computed: {
    storeOptions() {
      let arr = [];
      if (!Array.isArray(this.allStore)) return arr;
      this.allStore.map((val) => {
        arr.push({ label: val.name, value: val.id });
      });
      return arr;
    },
    sortedTableData() {
      let sortedData = [...this.refund_list];

      if (this.sortBy && this.sortOrder) {
        sortedData.sort((a, b) => {
          let aValue = a[this.sortBy];
          let bValue = b[this.sortBy];

          if (this.sortBy === "refund_rate") {
            aValue = parseFloat(aValue) || 0;
            bValue = parseFloat(bValue) || 0;
          } else if (typeof aValue === "string" && typeof bValue === "string") {
            aValue = aValue.toLowerCase();
            bValue = bValue.toLowerCase();
          } else {
            aValue = parseFloat(aValue) || 0;
            bValue = parseFloat(bValue) || 0;
          }

          if (this.sortOrder === "ascending") {
            return aValue > bValue ? 1 : aValue < bValue ? -1 : 0;
          } else {
            return aValue < bValue ? 1 : aValue > bValue ? -1 : 0;
          }
        });
      } else {
        // 默认按退款订单数降序
        sortedData.sort((a, b) => {
          const av = parseFloat(a.refund_num_sum) || 0;
          const bv = parseFloat(b.refund_num_sum) || 0;
          return bv - av;
        });
      }

      return sortedData;
    },
    currentPageData() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.sortedTableData.slice(start, end);
    },
    // 故障率：所有以"故障："开头的退款原因的总和
    unshippedCount() {
      if (
        !Array.isArray(this.refund_reason_analysis) ||
        this.refund_reason_analysis.length === 0
      )
        return 0;

      // 定义所有故障相关的退款原因代码
      const faultReasons = ["8", "13", "14", "18", "19"];

      // 计算所有故障原因的总和
      let totalFaultCount = 0;
      this.refund_reason_analysis.forEach((item) => {
        if (faultReasons.includes(String(item.reason))) {
          totalFaultCount += Number(item.count || 0);
        }
      });

      return totalFaultCount;
    },
    // 子表：未出货相关状态（过滤掉 出货成功）
    unshippedStatusList() {
      if (!Array.isArray(this.order_status_analysis)) return [];
      return this.order_status_analysis.filter((s) => {
        const name = this.$options.filters.outStatusFilter(s.order_out_status);
        return name !== "出货成功";
      });
    },
    // 子表：按占比从高到低排序
    rankedUnshippedStatusList() {
      return [...this.unshippedStatusList].sort(
        (a, b) => Number(b.percentage || 0) - Number(a.percentage || 0)
      );
    },
  },
  filters: {
    outStatusFilter(status) {
      const outMap = {
        SUCCESS: "出货成功",
        FAIL: "出货失败",
        CANCEL: "出货取消",
        OVERTIME: "结果未知",
        ING: "等待出货",
        未知: "未知",
        通讯超时: "通讯超时",
        出货异常: "出货异常",
        还未吐货: "还未吐货",
        出货失败: "出货失败",
        出货超时: "出货超时",
        等待吐货: "等待吐货",
        吐货成功: "吐货成功",
        其它故障: "其它故障",
        电机或传感器故障: "电机或传感器故障",
      };
      return outMap[status] || status;
    },
    reasonFilter(val) {
      if (val == null) return "-";

      let values = [];
      if (Array.isArray(val)) {
        values = val;
      } else if (typeof val === "string") {
        const trimmed = val.trim();
        if (trimmed === "") return "-";
        if (trimmed.includes(",") || trimmed.includes("，")) {
          values = trimmed
            .split(/[,，]/)
            .map((s) => s.trim())
            .filter(Boolean);
        } else {
          values = [trimmed];
        }
      } else if (typeof val === "number") {
        values = [String(val)];
      } else {
        return "-";
      }

      const reasons = {
        1: "质量: 商品损坏",
        2: "故障：未出货",
        3: "技术：重复支付",
        4: "技术：景区账号退款失败",
        5: "运营：出货与下单商品不符",
        6: "质量：外壳损坏",
        7: "质量：纪念章/大牌/集章册瑕疵",
        8: "故障：未出货",
        9: "技术：重复支付",
        10: "运营：出错货",
        11: "政策: 7天无理由",
        12: "测试: 测试",
        13: "故障: 大牌机器卡死",
        14: "故障: 大牌打印瑕疵",
        15: "777不出货",
        16: "777漏墨",
        18: "故障: 激光雕刻失败",
        19: "故障: 激光雕刻错位",
        20: "质量: 商品损坏",
      };

      const mapped = values
        .map((code) => reasons[Number(code)] || reasons[String(code)] || "-")
        .filter((text) => text && text !== "-");

      return mapped.length > 0 ? mapped.join("、") : "-";
    },
  },
  created() {
    this.setRangeDates();
    this.handleQuery();
  },
  mounted() {
    this.initEffects();
    this.startTimeUpdate();
    this.$nextTick(() => {
      this.initCharts();
    });
  },
  beforeDestroy() {
    this.cleanup();
  },
  methods: {
    getReason(params, value) {
      getRefundAnalysisReason(params)
        .then((resp) => {
          const list = Array.isArray(resp && resp.data) ? resp.data : [];
          // 标准化为空数组，避免 {} 导致第一次不清空
          this.refund_trend_analysis = list;
          // 更新明细图表
          this.$nextTick(() => {
            this.updateRefundTrendDetailChart();
          });
        })
        .catch(() => {
          // 失败时也清空，避免残留旧数据
          this.refund_trend_analysis = [];
          this.$nextTick(() => {
            this.updateRefundTrendDetailChart();
          });
        });
      // getRefundAnalysisStatus(params).then((resp) => {
      //   // this.order_status_analysis = resp.data;
      // });
      // getRefundAnalysisDevices(params).then((resp) => {
      //   // this.order_status_analysis = resp.data;
      // });
    },

    getStatus(params) {
      // 无有效状态时，不请求接口，直接清空明细并刷新图表
      // if (!params || !params.status) {
      //   this.order_status_detail = [];
      //   this.$nextTick(() => {
      //     this.updateOrderStatusDetailChart &&
      //       this.updateOrderStatusDetailChart();
      //   });
      //   return;
      // }
      getRefundAnalysisStatus(params)
        .then((resp) => {
          const list = Array.isArray(resp && resp.data) ? resp.data : [];
          this.order_status_detail = list;
          this.$nextTick(() => {
            this.updateOrderStatusDetailChart &&
              this.updateOrderStatusDetailChart();
          });
        })
        .catch(() => {
          // 失败时也清空，避免残留旧数据
          this.order_status_detail = [];
          this.$nextTick(() => {
            this.updateOrderStatusDetailChart &&
              this.updateOrderStatusDetailChart();
          });
        });
    },

    // 处理订单状态饼状图点击事件
    handleOrderStatusClick(params) {
      if (params.componentType === "series" && params.seriesType === "pie") {
        const clickedStatus = params.name; // 已是中文展示名

        // 仅"出货成功/出货失败"用英文码，其它一律传中文
        let mapped;
        if (clickedStatus === "出货成功") {
          mapped = "SUCCESS";
        } else if (clickedStatus === "出货失败") {
          mapped = "FAIL";
        } else {
          mapped = clickedStatus; // 出货异常/通讯超时/未知 等直接传中文
        }

        let queryForm = this.getReq();
        let data = {
          start: queryForm.start,
          end: queryForm.end,
          company_id_list: queryForm.storeIdList,
          device_id_list: queryForm.deviceIdList,
          source: this.category || undefined,
          status: mapped,
        };
        console.log("订单状态筛选参数:", data);
        this.getStatus(data);

        this.currentStatus = clickedStatus;
        this.$message({
          message: `已筛选: ${clickedStatus}`,
          type: "success",
          duration: 2000,
        });
      }
    },

    // 处理退款原因饼状图点击事件
    handleRefundReasonClick(params) {
      if (params.componentType === "series" && params.seriesType === "pie") {
        const clickedReason = params.name;

        // 定义退款原因映射对象
        const reasons = {
          1: "质量: 商品损坏",
          2: "故障：未出货",
          3: "技术：重复支付",
          4: "技术：景区账号退款失败",
          5: "运营：出货与下单商品不符",
          6: "质量：外壳损坏",
          7: "质量：纪念章/大牌/集章册瑕疵",
          8: "故障：未出货",
          9: "技术：重复支付",
          10: "运营：出错货",
          11: "政策: 7天无理由",
          12: "测试: 测试",
          13: "故障: 大牌机器卡死",
          14: "故障: 大牌打印瑕疵",
          15: "777不出货",
          16: "777漏墨",
          18: "故障: 激光雕刻失败",
          19: "故障: 激光雕刻错位",
          20: "质量: 商品损坏",
        };

        // 根据clickedReason找到对应的key
        const key = Object.keys(reasons).find(
          (key) => reasons[key] === clickedReason
        );

        if (key) {
          let queryForm = this.getReq();
          let data = {
            start: queryForm.start,
            end: queryForm.end,
            company_id_list: queryForm.storeIdList,
            device_id_list: queryForm.deviceIdList,
            source: this.category || undefined,
            reason: key,
          };
          console.log("筛选数据:", data);
          this.getReason(data);

          // 设置当前筛选的退款原因
          this.currentReason = clickedReason;

          // 添加用户反馈
          this.$message({
            message: `已筛选: ${clickedReason}`,
            type: "success",
            duration: 2000,
          });
        } else {
          console.warn("未找到对应的原因代码:", clickedReason);
        }
      }
    },
    isUnshippedReason(code) {
      const c = String(code).trim();
      if (c === "2" || c === "8") return true;
      const name = this.$options.filters.reasonFilter(c) || "";
      return String(name).includes("未出货");
    },
    getBarWidth(value, max) {
      const v = Number(value || 0);
      const m = Math.max(Number(max || 0), 10); // 设置最小值为10
      const pct = Math.min(100, Math.max(0, (v / m) * 100));
      return pct.toFixed(2) + "%";
    },
    // 初始化特效
    initEffects() {
      this.initMatrixRain();
      this.startParticles();
    },

    // 数字雨效果
    initMatrixRain() {
      const matrixRef = this.$refs.matrixCanvas;
      const canvas = matrixRef && matrixRef.querySelector("canvas");
      if (!canvas) return;

      const ctx = canvas.getContext("2d");
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;

      const matrix = "ABCDEFGHIJKLMNOPQRSTUVWXYZ123456789@#$%^&*()";
      const drops = [];
      const columns = canvas.width / 10;

      for (let x = 0; x < columns; x++) {
        drops[x] = 1;
      }

      const draw = () => {
        ctx.fillStyle = "rgba(10, 14, 41, 0.04)";
        ctx.fillRect(0, 0, canvas.width, canvas.height);

        ctx.fillStyle = "#00f2ff";
        ctx.font = "10px monospace";

        for (let i = 0; i < drops.length; i++) {
          const text = matrix[Math.floor(Math.random() * matrix.length)];
          ctx.fillText(text, i * 10, drops[i] * 10);

          if (drops[i] * 10 > canvas.height && Math.random() > 0.975) {
            drops[i] = 0;
          }
          drops[i]++;
        }
      };

      this.matrixInterval = setInterval(draw, 35);
    },

    // 粒子效果
    startParticles() {
      const createParticle = () => {
        const container = this.$refs.particles;
        if (!container) return;

        for (let i = 0; i < 5; i++) {
          const particle = document.createElement("div");
          particle.className = "particle";
          particle.style.left = Math.random() * 100 + "%";
          particle.style.animationDelay = Math.random() * 10 + "s";
          particle.style.animationDuration = Math.random() * 10 + 10 + "s";
          container.appendChild(particle);

          setTimeout(() => {
            if (particle.parentNode) {
              particle.parentNode.removeChild(particle);
            }
          }, 20000);
        }
      };

      this.particleInterval = setInterval(createParticle, 5000);
      createParticle(); // 立即创建一些粒子
    },

    // 时间更新
    startTimeUpdate() {
      this.timeInterval = setInterval(() => {
        this.currentTime = new Date().toLocaleTimeString("zh-CN", {
          hour12: false,
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        });

        // 更新系统状态
        this.systemStatus.cpu = Math.floor(Math.random() * 30) + 15;
        this.systemStatus.memory = Math.floor(Math.random() * 40) + 50;
      }, 1000);
    },

    // 清理资源
    cleanup() {
      if (this.timeInterval) clearInterval(this.timeInterval);
      if (this.matrixInterval) clearInterval(this.matrixInterval);
      if (this.particleInterval) clearInterval(this.particleInterval);
      this.disposeCharts();
    },

    // 设置默认日期
    setRangeDates() {
      // const today = new Date();
      // const yesterday = new Date(today);
      // yesterday.setDate(today.getDate() - 1); // 设置为昨天

      // // 如果昨天是1号，则设置为上个月1号到月底
      // if (yesterday.getDate() === 1) {
      //   const lastMonth = new Date(today);
      //   lastMonth.setMonth(today.getMonth() - 1);
      //   lastMonth.setDate(1);

      //   const lastMonthEnd = new Date(today);
      //   lastMonthEnd.setDate(0); // 设置为上个月最后一天

      //   this.reqForm.timeRange = [
      //     this.formatDate(lastMonth),
      //     this.formatDate(lastMonthEnd),
      //   ];
      // } else {
      //   // 否则设置为当月1号到昨天
      //   const firstDayOfMonth = new Date(
      //     today.getFullYear(),
      //     today.getMonth(),
      //     1
      //   );
      //   this.reqForm.timeRange = [
      //     this.formatDate(firstDayOfMonth),
      //     this.formatDate(yesterday),
      //   ];
      // }
      const today = new Date();
      const year = today.getFullYear();
      const month = today.getMonth(); // 月份从0开始，0为1月
      const day = today.getDate();

      let startDate, endDate;

      if (month === 0 && day === 1) {
        // 如果今天是1月1日，起始和结束日期为去年12月的1号和31号
        startDate = new Date(year - 1, 11, 1);
        endDate = new Date(year - 1, 11, 31);
      } else if (day === 1) {
        // 如果今天是一个月的1号，起始日期为上一个月的1号，结束日期为上一个月的最后一天
        startDate = new Date(year, month - 1, 1);
        endDate = new Date(year, month, 0); // 设置日期为0将自动设置为上个月的最后一天
      } else {
        // 如果今天是一个月中的其他日期，起始日期为这个月的1号，结束日期为昨天
        startDate = new Date(year, month, 1);
        endDate = new Date(year, month, day - 1);
      }

      this.reqForm.timeRange = [this.formatDate(startDate), this.formatDate(endDate)]
    },

    // 格式化日期
    formatDate(date) {
      return (
        date.getFullYear() +
        "-" +
        String(date.getMonth() + 1).padStart(2, "0") +
        "-" +
        String(date.getDate()).padStart(2, "0")
      );
    },

    // 格式化数字
    formatNumber(value) {
      if (typeof value === "object" && value.refundOrders) {
        return value.refundOrders.toLocaleString();
      }
      return value ? value.toLocaleString() : "0";
    },

    // 获取请求参数
    getReq() {
      var queryForm = { ...this.reqForm };
      if (this.reqForm.timeRange.length > 0) {
        const [startDate, endDate] = this.reqForm.timeRange;
        queryForm.start = startDate;
        queryForm.end = endDate;
      } else {
        queryForm.start = "";
        queryForm.end = "";
      }

      queryForm.storeIdList =
        queryForm.storeIdList.length > 0 ? queryForm.storeIdList : [];
      queryForm.deviceIdList =
        queryForm.deviceIdList.length > 0 ? queryForm.deviceIdList : [];
      return queryForm;
    },

    // 处理查询
    handleQuery() {
      var queryForm = this.getReq();
      let params = {
        start: queryForm.start,
        end: queryForm.end,
        company_id_list: queryForm.storeIdList,
        device_id_list: queryForm.deviceIdList,
        source: this.category || undefined,
        reason: 0,
        region_id: this.region * 1, // 区域id
      };

      // 重置筛选条件
      this.currentReason = "";
      this.currentStatus = "";

      // 清空右侧明细数据，避免显示上次的筛选数据
      this.order_status_detail = [];
      this.refundReasonDetailList = [];
      this.orderStatusDetailList = [];

      // 重置明细图表的提示信息
      this.$nextTick(() => {
        // 清空订单状态明细图表
        if (this.updateOrderStatusDetailChart) {
          this.updateOrderStatusDetailChart();
        }
        // 清空退款原因明细图表
        if (this.updateRefundTrendDetailChart) {
          this.updateRefundTrendDetailChart();
        }
      });

      this.loadData(params);
      this.getReason(params, 0);
      // 初始查询不请求订单状态设备明细，等待用户点击左侧状态后再请求
      this.getStatus(params);
    },

    // 加载数据
    loadData(params) {
      this.tableLoading = true;
      this.currentPage = 1;

      getRefundAnalysis(params)
        .then((res) => {
          if (res && res.code === 2000 && res.data) {
            this.order_status_analysis = res.data.order_status_analysis || [];
            this.refund_list = res.data.refund_list || [];
            this.refund_reason_analysis = res.data.refund_reason_analysis || [];
            this.summary = res.data.summary || {};

            // 计算表格进度条最大值
            const list = this.refund_list || [];
            this.maxRefundOrders = Math.max(
              1,
              ...list.map((i) => Number(i.refund_num_sum || 0))
            );
            this.maxRecordCount = Math.max(
              1,
              ...list.map((i) => Number(i.record_count || 0))
            );
            this.maxAutoCount = Math.max(
              1,
              ...list.map((i) => Number(i.is_auto_1_count || 0))
            );
            this.maxManualCount = Math.max(
              1,
              ...list.map((i) => Number(i.is_auto_0_count || 0))
            );

            this.$nextTick(() => {
              this.initCharts();
            });
          }
        })
        .catch((err) => {
          this.$message.error(err.message || "数据加载失败");
          this.order_status_analysis = [];
          this.refund_list = [];
          this.refund_reason_analysis = [];
          this.summary = {};
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },

    // 获取数据参数
    getdata() {
      var queryForm = this.getReq();
      let params = {
        start: queryForm.start,
        end: queryForm.end,
        company_id_list: queryForm.storeIdList,
        device_id_list: queryForm.deviceIdList,
        source: this.category || undefined,
      };
      return params;
    },

    // 导出功能
    showReasonDetail() {
      let params = this.getdata();
      this.$confirm(`确认下载退款原因数据吗？`).then(() => {
        getRefundAnalysisDownloadTwo(params)
          .then((data) => {
            this.download(data, params);
          })
          .catch((error) => {
            this.$message.error(error);
          });
      });
    },
    showReasonDetail_device(value) {
      let params = this.getdata();
      if (value === 1) {
        this.$confirm(`确认下载退款原因数据吗？`).then(() => {
          // getRefundAnalysisDownloadStatus(params)
          //   .then((data) => {
          //     this.download(data, params);
          //   })
          //   .catch((error) => {
          //     this.$message.error(error);
          //   });
          getRefundAnalysisDownloadReason(params)
            .then((data) => {
              this.download(data, params);
            })
            .catch((error) => {
              this.$message.error(error);
            });
        });
      } else if (value === 2) {
        console.log(params);
        this.$confirm(`确认下载退款原因日志数据吗？`).then(() => {
          // getRefundAnalysisDownloadStatus(params)
          //   .then((data) => {
          //     this.download(data, params);
          //   })
          //   .catch((error) => {
          //     this.$message.error(error);
          //   });
          getrefundLogDownload({
            start: params.start,
            end: params.end,
            page: 1,
            pageSize: 20,
            reason: undefined,
            genesis: [],
          })
            .then((data) => {
              this.download(data, params);
            })
            .catch((error) => {
              this.$message.error(error);
            });
        });
      }
    },

    showStatusDetail_device() {
      let params = this.getdata();
      this.$confirm(`确认下载订单状态数据吗？`).then(() => {
        getRefundAnalysisDownloadStatus(params)
          .then((data) => {
            this.download(data, params);
          })
          .catch((error) => {
            this.$message.error(error);
          });
      });
    },

    showStatusDetail() {
      let params = this.getdata();
      this.$confirm(`确认下载订单状态数据吗？`).then(() => {
        getRefundAnalysisDownload(params)
          .then((data) => {
            this.download(data, params);
          })
          .catch((error) => {
            this.$message.error(error);
          });
      });
    },

    downloadTable() {
      let params = this.getdata();
      this.$confirm(`确认下载详细数据吗？`).then(() => {
        getRefundAnalysisDownloadThree(params)
          .then((data) => {
            this.download(data, params);
          })
          .catch((error) => {
            this.$message.error(error);
          });
      });
    },

    // 下载文件
    download(resp, params) {
      const fileName = `${params.start}-${params.end}.xlsx`;
      const blob = new Blob([resp.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, fileName);
      } else {
        const href = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = href;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(href);
      }
    },

    // 分页处理
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
    },

    handleCurrentChange(val) {
      this.currentPage = val;
    },

    // 排序处理
    handleSortChange({ column, prop, order }) {
      this.sortBy = prop;
      this.sortOrder = order;
      this.currentPage = 1;
    },

    // 初始化图表
    initCharts() {
      this.initRefundReasonChart();
      this.initOrderStatusChart();
      this.initRefundTrendChart();
      this.initRefundTrendDetailChart();
      this.initOrderStatusDetailChart();
    },

    // 初始化退款原因图表
    initRefundReasonChart() {
      if (this.refundReasonChart) {
        this.refundReasonChart.dispose();
      }
      if (this.$refs.refundReasonChart) {
        this.refundReasonChart = echarts.init(this.$refs.refundReasonChart);
        this.updateRefundReasonChart();
      }
    },

    // 更新退款原因图表
    updateRefundReasonChart() {
      const option = {
        backgroundColor: "transparent",
        tooltip: {
          trigger: "item",
          backgroundColor: "rgba(0, 0, 0, 0.9)",
          borderColor: "#ffffff",
          borderWidth: 1,
          borderRadius: 8,
          textStyle: {
            color: "#ffffff",
            fontSize: 12,
          },
          formatter: function (params) {
            const originalValue = params.data.originalValue || params.value;
            return `<div style="padding: 8px;">
              <div style="font-weight: bold; margin-bottom: 4px;">${params.name}</div>
              <div style="color: #ffffff;">数量: ${originalValue}</div>
              <div style="color: #ffffff;">占比: ${params.percent}%</div>
              <div style="color: #58D9F9; font-size: 10px; margin-top: 4px;">点击筛选此原因</div>
            </div>`;
          },
        },
        legend: {
          orient: "horizontal",
          bottom: "0%",
          textStyle: {
            color: "#ffffff",
            fontSize: 12,
            fontWeight: "bold",
          },
          itemGap: 8,
          itemWidth: 12,
          itemHeight: 8,
          data: this.refund_reason_analysis.map((item) =>
            this.$options.filters.reasonFilter(item.reason)
          ),
          // 响应式图例配置
          type: "scroll",
          pageButtonItemGap: 5,
          pageButtonGap: 10,
          pageButtonPosition: "end",
          pageFormatter: "{current}/{total}",
          pageIconColor: "#ffffff",
          pageIconInactiveColor: "#666666",
          pageIconSize: 12,
          pageTextStyle: {
            color: "#ffffff",
            fontSize: 10,
          },
        },
        series: [
          {
            name: "退款原因",
            type: "pie",
            radius: ["30%", "75%"],
            center: ["50%", "45%"],
            roseType: "area", // 启用左侧玫瑰图模式
            minAngle: 35, // 设置最小角度，进一步放大最小值
            itemGap: 15, // 扇形之间的间距，进一步增加间距
            data: this.refund_reason_analysis.map((item, index) => ({
              name: this.$options.filters.reasonFilter(item.reason),
              value: Math.max(item.count, 5), // 确保最小值为5，让小于10的值也能显示
              originalValue: item.count, // 保存原始值用于提示框显示
              itemStyle: {
                color: [
                  "#4a90e2",
                  "#7ed321",
                  "#5a5a5a",
                  "#f5a623",
                  "#50e3c2",
                  "#f8e71c",
                  "#ff6b6b",
                  "#9b59b6",
                ][index % 8],
                borderColor: "#ffffff",
                borderWidth: 2,
                borderRadius: 8,
                shadowBlur: 15,
                shadowColor: "rgba(0, 0, 0, 0.3)",
                shadowOffsetX: 2,
                shadowOffsetY: 2,
              },
            })),
            emphasis: {
              itemStyle: {
                shadowBlur: 25,
                shadowColor: "rgba(255, 255, 255, 0.6)",
                shadowOffsetX: 5,
                shadowOffsetY: 5,
                borderWidth: 3,
                borderColor: "#ffffff",
                borderRadius: 10,
                cursor: "pointer",
              },
            },
            label: {
              show: true,
              position: "outside",
              color: "#ffffff",
              fontSize: 10,
              fontWeight: "bold",
              formatter: function (params) {
                const originalValue = params.data.originalValue || params.value;
                // 在窄屏幕下缩短标签文本
                const name =
                  params.name.length > 8
                    ? params.name.substring(0, 8) + "..."
                    : params.name;
                return `${name}\n${originalValue}`;
              },
              lineHeight: 12,
              // 防止标签重叠
              overflow: "truncate",
              width: 60,
            },
            labelLine: {
              show: true,
              length: 12,
              length2: 8,
              lineStyle: {
                color: "#ffffff",
                width: 1,
              },
              // 防止标签线重叠
              smooth: true,
              smoothness: 0.2,
            },
            animationType: "scale",
            animationEasing: "elasticOut",
            animationDelay: (idx) => idx * 150,
          },
        ],
      };
      this.refundReasonChart.setOption(option);

      // 添加点击事件
      this.refundReasonChart.off("click");
      this.refundReasonChart.on("click", (params) => {
        this.handleRefundReasonClick(params);
      });
    },

    // 初始化订单状态图表
    initOrderStatusChart() {
      if (this.orderStatusChart) {
        this.orderStatusChart.dispose();
      }
      if (this.$refs.orderStatusChart) {
        this.orderStatusChart = echarts.init(this.$refs.orderStatusChart);
        this.updateOrderStatusChart();
      }
    },

    // 更新订单状态图表
    updateOrderStatusChart() {
      const statuses = this.order_status_analysis || [];
      const option = {
        backgroundColor: "transparent",
        tooltip: {
          trigger: "item",
          backgroundColor: "rgba(0, 0, 0, 0.9)",
          borderColor: "#ffffff",
          borderWidth: 1,
          borderRadius: 8,
          textStyle: {
            color: "#ffffff",
            fontSize: 12,
          },
          formatter: function (params) {
            const originalValue = params.data.originalValue || params.value;
            return `<div style="padding: 8px;">
              <div style="font-weight: bold; margin-bottom: 4px;">${params.name}</div>
              <div style="color: #ffffff;">数量: ${originalValue}</div>
              <div style="color: #ffffff;">占比: ${params.percent}%</div>
              <div style="color: #58D9F9; font-size: 10px; margin-top: 4px;">点击筛选此状态</div>
            </div>`;
          },
        },
        legend: {
          orient: "horizontal",
          bottom: "0%",
          textStyle: {
            color: "#ffffff",
            fontSize: 10,
            fontWeight: "bold",
          },
          itemGap: 8,
          itemWidth: 12,
          itemHeight: 8,
          data: statuses.map((item) =>
            this.$options.filters.outStatusFilter(item.order_out_status)
          ),
          // 响应式图例配置
          type: "scroll",
          pageButtonItemGap: 5,
          pageButtonGap: 10,
          pageButtonPosition: "end",
          pageFormatter: "{current}/{total}",
          pageIconColor: "#ffffff",
          pageIconInactiveColor: "#666666",
          pageIconSize: 12,
          pageTextStyle: {
            color: "#ffffff",
            fontSize: 10,
          },
        },
        series: [
          {
            name: "订单状态",
            type: "pie",
            radius: ["30%", "75%"],
            center: ["50%", "45%"],
            roseType: "area", // 启用左侧玫瑰图模式
            minAngle: 35, // 设置最小角度
            itemGap: 15, // 扇形之间的间距
            data: statuses.map((item, index) => ({
              name: this.$options.filters.outStatusFilter(
                item.order_out_status
              ),
              value: Math.max(item.count, 5), // 确保最小值为5
              originalValue: item.count, // 保存原始值用于提示框显示
              originalStatus: item.order_out_status,
              itemStyle: {
                color: [
                  "#ff6b6b",
                  "#4ecdc4",
                  "#45b7d1",
                  "#96ceb4",
                  "#feca57",
                  "#ff9ff3",
                  "#54a0ff",
                  "#5f27cd",
                ][index % 8],
                borderColor: "#ffffff",
                borderWidth: 2,
                borderRadius: 8,
                shadowBlur: 15,
                shadowColor: "rgba(0, 0, 0, 0.3)",
                shadowOffsetX: 2,
                shadowOffsetY: 2,
              },
            })),
            emphasis: {
              itemStyle: {
                shadowBlur: 25,
                shadowColor: "rgba(255, 255, 255, 0.6)",
                shadowOffsetX: 5,
                shadowOffsetY: 5,
                borderWidth: 3,
                borderColor: "#ffffff",
                borderRadius: 10,
                cursor: "pointer",
              },
            },
            label: {
              show: true,
              position: "outside",
              color: "#ffffff",
              fontSize: 10,
              fontWeight: "bold",
              formatter: function (params) {
                const originalValue = params.data.originalValue || params.value;
                // 在窄屏幕下缩短标签文本
                const name =
                  params.name.length > 6
                    ? params.name.substring(0, 6) + "..."
                    : params.name;
                return `${name}\n${originalValue}`;
              },
              lineHeight: 12,
              // 防止标签重叠
              overflow: "truncate",
              width: 50,
            },
            labelLine: {
              show: true,
              length: 12,
              length2: 8,
              lineStyle: {
                color: "#ffffff",
                width: 1,
              },
              // 防止标签线重叠
              smooth: true,
              smoothness: 0.2,
            },
            animationType: "scale",
            animationEasing: "elasticOut",
            animationDelay: (idx) => idx * 150,
          },
        ],
      };
      this.orderStatusChart.setOption(option);

      // 添加点击事件
      this.orderStatusChart.off("click");
      this.orderStatusChart.on("click", (params) => {
        this.handleOrderStatusClick(params);
      });
    },

    // 初始化趋势图表
    initRefundTrendChart() {
      if (this.refundTrendChart) {
        this.refundTrendChart.dispose();
      }
      if (this.$refs.refundTrendChart) {
        this.refundTrendChart = echarts.init(this.$refs.refundTrendChart);
        this.updateRefundTrendChart();
      }
    },

    // 初始化退款趋势明细图表
    initRefundTrendDetailChart() {
      if (this.refundTrendDetailChart) {
        this.refundTrendDetailChart.dispose();
      }
      if (this.$refs.refundTrendDetailChart) {
        this.refundTrendDetailChart = echarts.init(
          this.$refs.refundTrendDetailChart
        );
        this.updateRefundTrendDetailChart();
      }
    },

    // 初始化订单状态明细图表
    initOrderStatusDetailChart() {
      if (this.orderStatusDetailChart) {
        this.orderStatusDetailChart.dispose();
      }
      if (this.$refs.orderStatusDetailChart) {
        this.orderStatusDetailChart = echarts.init(
          this.$refs.orderStatusDetailChart
        );
        this.updateOrderStatusDetailChart();
      }
    },

    // 更新退款趋势明细图表 - 改为列表样式
    updateRefundTrendDetailChart() {
      const data = Array.isArray(this.refund_trend_analysis)
        ? this.refund_trend_analysis
        : [];

      // 无数据时立即清空列表并返回
      if (data.length === 0) {
        this.refundReasonDetailList = [];
        this.maxReasonCount = 1;
        this.$nextTick(() => {
          const reasonList = document.querySelector(".reason-detail-list");
          if (reasonList) reasonList.scrollTop = 0;
        });
        return;
      }

      // 按设备分组统计数量（类似订单状态分析的处理方式）
      const deviceStats = {};
      data.forEach((item) => {
        const key = `${item.company_name} - ${item.device_name}`;
        if (!deviceStats[key]) {
          deviceStats[key] = {
            company_name: item.company_name,
            device_name: item.device_name,
            device_id: item.device_id,
            channel: item.channel,
            count: 0,
            reason: item.refund_reason,
          };
        }
        deviceStats[key].count += Number(item.count_num || 0);
      });

      // 转换为数组并排序
      const sortedData = Object.values(deviceStats).sort(
        (a, b) => b.count - a.count
      );

      // 更新数据
      this.refundReasonDetailList = sortedData;
      this.maxReasonCount = Math.max(
        ...sortedData.map((item) => item.count),
        1
      );

      // 滚动到顶部
      this.$nextTick(() => {
        const reasonList = document.querySelector(".reason-detail-list");
        if (reasonList) {
          reasonList.scrollTop = 0;
        }
      });
    },

    // 更新订单状态明细图表 - 改为列表样式
    updateOrderStatusDetailChart() {
      const data = this.order_status_detail || [];

      // 按设备分组统计数量
      const deviceStats = {};
      data.forEach((item) => {
        const key = `${item.company_name} - ${item.device_name}`;
        if (!deviceStats[key]) {
          deviceStats[key] = {
            company_name: item.company_name,
            device_name: item.device_name,
            device_id: item.device_id,
            channel: item.channel,
            count: 0,
            status: item.order_out_status,
          };
        }
        // order_id代表数量，累加数量值
        deviceStats[key].count += Number(item.order_id || 0);
      });

      // 转换为数组并排序
      const sortedData = Object.values(deviceStats).sort(
        (a, b) => b.count - a.count
      );

      // 更新数据
      this.orderStatusDetailList = sortedData;
      this.maxStatusCount = Math.max(
        ...sortedData.map((item) => item.count),
        1
      );

      // 滚动到顶部
      this.$nextTick(() => {
        const statusList = document.querySelector(".status-detail-list");
        if (statusList) {
          statusList.scrollTop = 0;
        }
      });
    },

    // 更新趋势图表
    updateRefundTrendChart() {
      // 使用退款订单数进行排序
      const list = Array.isArray(this.refund_list) ? [...this.refund_list] : [];
      const sortedByOrders = list.sort(
        (a, b) => Number(b.refund_num_sum || 0) - Number(a.refund_num_sum || 0)
      );

      const names = sortedByOrders.map((item) => item.company_name);
      const orderData = sortedByOrders.map((item) =>
        Math.max(Number(item.refund_num_sum || 0), 0)
      );

      // 退款率数据（百分比），用于折线图（采用分段映射：0-5%→0-50，5-100%→50-100）
      const transformRate = (ratePct) => {
        if (ratePct <= 5) return ratePct * 10; // 0..5 → 0..50
        return 50 + (ratePct - 5) * (50 / 95); // 5..100 → 50..100
      };

      const refundRateLineData = sortedByOrders.map((item) => {
        const rate = Math.max((item.refund_rate || 0) * 100, 0);
        return {
          value: Number(transformRate(rate).toFixed(2)),
          trueRate: Number(rate.toFixed(2)),
        };
      });

      const option = {
        backgroundColor: "transparent",
        title: {
          text: "景区退款分析排行榜",
          subtext: "",
          left: "center",
          textStyle: {
            color: "#ffffff",
            fontSize: 18,
            fontWeight: "bold",
          },
          subtextStyle: {
            color: "rgba(255, 255, 255, 0.7)",
            fontSize: 12,
          },
        },
        tooltip: {
          trigger: "axis",
          backgroundColor: "rgba(0, 0, 0, 0.9)",
          borderColor: "#ffffff",
          borderWidth: 1,
          borderRadius: 8,
          textStyle: {
            color: "#ffffff",
            fontSize: 12,
          },
          formatter: function (params) {
            const scenicName = params[0].name;
            const data = sortedByOrders.find(
              (item) => item.company_name === scenicName
            );
            let tooltipContent = `<div style="padding: 8px;">\n               <div style="font-weight: bold; margin-bottom: 8px; color: #ffffff; font-size: 14;">${scenicName}</div>`;

            params.forEach((param) => {
              if (param.seriesName === "退款订单数") {
                tooltipContent += `<div style="margin: 4px 0; color: #ffffff;">\n                 <span style="color: ${param.color};">●</span> 退款订单数: ${param.value}\n               </div>`;
              } else if (param.seriesName === "退款率") {
                const trueRate =
                  param.data && param.data.trueRate != null
                    ? Number(param.data.trueRate)
                    : Number(param.value);
                const isHighRate = trueRate > 5;
                const rateColor = isHighRate ? "#ff4757" : "#feca57";
                const rateText = isHighRate ? "⚠️ 高退款率" : "✅ 正常范围";
                tooltipContent += `<div style="margin: 4px 0; color: #ffffff;">\n                 <span style="color: ${
                  param.color
                };">●</span> 退款率: ${trueRate.toFixed(
                  2
                )}%\n                 <span style="color: ${rateColor}; margin-left: 8px;">${rateText}</span>\n               </div>`;
              }
            });

            if (data) {
              tooltipContent += `<div style="margin-top: 8px; padding-top: 8px; border-top: 1px solid rgba(255,255,255,0.3);">\n                 <div style="margin: 4px 0; color: #4ecdc4;">● 退款次数: ${
                data.record_count || 0
              }</div>\n                 <div style="margin: 4px 0; color: #45b7d1;">● 自动退款: ${
                data.is_auto_1_count || 0
              }</div>\n                 <div style="margin: 4px 0; color: #96ceb4;">● 手动退款: ${
                data.is_auto_0_count || 0
              }</div>\n               </div>`;
            }

            tooltipContent += "</div>";
            return tooltipContent;
          },
        },
        legend: {
          data: ["退款订单数", "退款率"],
          top: 40,
          textStyle: {
            color: "#ffffff",
            fontSize: 12,
            fontWeight: "bold",
          },
          itemGap: 15,
          itemWidth: 15,
          itemHeight: 10,
        },
        grid: {
          left: "5%",
          right: "5%",
          bottom: "6%",
          top: "25%",
          containLabel: true,
        },
        dataZoom: [
          {
            type: "slider",
            show: sortedByOrders.length > 10, // 只有数据项超过10个时才显示滑轨
            xAxisIndex: 0,
            start: 0,
            end: Math.min(100, (8 / sortedByOrders.length) * 100), // 默认显示8个，让标签更清晰
            // 禁用悬浮细节展示
            showDetail: false,
            // 最大拉伸不超过100个
            maxSpan:
              sortedByOrders.length > 0
                ? Math.min(100, (100 / sortedByOrders.length) * 100)
                : 100,
            // 设置最小宽度，防止过窄（最少显示6个）
            minSpan:
              sortedByOrders.length > 0
                ? Math.min(100, (6 / sortedByOrders.length) * 100)
                : 20,
            height: 20,
            bottom: 10,
            borderColor: "rgba(255, 255, 255, 0.3)",
            backgroundColor: "rgba(255, 255, 255, 0.1)",
            fillerColor: "rgba(255, 255, 255, 0.2)",
            handleStyle: {
              color: "#ffffff",
              borderColor: "rgba(255, 255, 255, 0.5)",
              width: 30, // 设置滑块最小宽度
            },
            textStyle: {
              color: "#ffffff",
              fontSize: 12,
            },
            labelFormatter: function (value, valueStr) {
              return valueStr;
            },
          },
        ],
        xAxis: {
          type: "category",
          data: names,
          axisLabel: {
            interval: "auto", // 自动计算间隔，只显示部分标签
            rotate: 0, // 改为水平显示，更美观
            margin: 8,
            fontSize: 11,
            color: "#ffffff",
            fontWeight: "bold",
            formatter: (value) => {
              // 保持原始景区名称，只做长度限制
              if (!value) return "";

              // 限制长度，超过8个字符则截断
              if (value.length > 8) {
                return value.substring(0, 8) + "...";
              }

              return value;
            },
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "rgba(255, 255, 255, 0.3)",
              width: 1,
            },
          },
          axisTick: {
            show: true,
            lineStyle: { color: "rgba(255, 255, 255, 0.2)" },
          },
          // 减少网格干扰：分类轴不显示分割线
          splitLine: { show: false },
        },
        yAxis: [
          {
            type: "value",
            name: "数量",
            min: 0,
            nameTextStyle: { color: "#ffffff" },
            axisLabel: { fontSize: 12, color: "#ffffff" },
            axisLine: { lineStyle: { color: "rgba(255, 255, 255, 0.2)" } },
            // 减少分割线数量并变淡
            splitNumber: 4,
            splitLine: { lineStyle: { color: "rgba(255, 255, 255, 0.08)" } },
          },
          {
            type: "value",
            name: "退款率(%)",
            nameTextStyle: { color: "#ffffff" },
            min: 0,
            max: 100,
            // 调整标线间隔，让5%分界线更明显
            interval: 25,
            axisLabel: {
              color: "#ffffff",
              formatter: (val) => {
                // 将映射值转换回实际百分比显示
                if (val <= 50) {
                  return `${(val / 10).toFixed(1)}%`; // 0-50 对应 0-5%
                } else {
                  return `${(5 + (val - 50) * (95 / 50)).toFixed(0)}%`; // 50-100 对应 5-100%
                }
              },
            },
            axisLine: { lineStyle: { color: "rgba(255, 255, 255, 0.2)" } },
            // 同样减少并淡化网格线
            splitNumber: 4,
            splitLine: { lineStyle: { color: "rgba(255, 255, 255, 0.06)" } },
          },
        ],
        series: [
          // 柱状图显示退款订单数（按订单数排序）
          {
            name: "退款订单数",
            type: "bar",
            yAxisIndex: 0,
            barWidth: "40%",
            data: orderData,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#4a90e2" },
                { offset: 1, color: "#7ed321" },
              ]),
              borderRadius: [8, 8, 0, 0],
              shadowBlur: 15,
              shadowColor: "rgba(0,0,0,0.35)",
            },
            label: {
              show: true,
              position: "top",
              color: "#ffffff",
              fontSize: 10,
              fontWeight: "bold",
              formatter: (p) => (Number(p.value) || 0).toLocaleString(),
            },
            animationDelay: (idx) => idx * 100,
          },
          // 折线图显示退款率（百分比，使用分段映射值绘图）
          {
            name: "退款率",
            type: "line",
            yAxisIndex: 1,
            smooth: true,
            symbol: "diamond",
            symbolSize: 10,
            data: refundRateLineData,
            lineStyle: {
              width: 3,
              color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                { offset: 0, color: "#feca57" },
                { offset: 1, color: "#ff4757" },
              ]),
              shadowBlur: 12,
              shadowColor: "rgba(255, 107, 107, 0.4)",
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "rgba(255, 160, 122, 0.25)" },
                { offset: 1, color: "rgba(255, 160, 122, 0.05)" },
              ]),
            },
            emphasis: {
              focus: "series",
              itemStyle: {
                shadowBlur: 20,
                shadowColor: "rgba(255,107,107,0.8)",
              },
            },
            label: {
              show: true,
              position: "top",
              color: "#ffffff",
              fontSize: 10,
              fontWeight: "bold",
              formatter: (p) =>
                `${(p.data && p.data.trueRate != null
                  ? p.data.trueRate
                  : p.value
                ).toFixed(2)}%`,
            },
            markLine: {
              symbol: "none",
              lineStyle: { color: "#ff4757", type: "dashed", width: 2 },
              data: [{ yAxis: 50, name: "5%分界" }], // 5% 对应映射后的 50
              label: {
                formatter: "5% 分界",
                color: "#ff4757",
                backgroundColor: "rgba(0,0,0,0.7)",
                padding: [4, 8],
                borderRadius: 6,
                fontSize: 12,
                fontWeight: "bold",
                position: "insideEndTop",
              },
            },
            animationDelay: (idx) => idx * 120 + 400,
            animationDuration: 1200,
            animationEasing: "cubicOut",
          },
        ],
      };

      option.animationDuration = 2000;
      option.animationEasing = "cubicOut";

      this.refundTrendChart.setOption(option);
    },

    // 刷新趋势图表
    refreshTrendChart() {
      if (this.refundTrendChart) {
        this.updateRefundTrendChart();
      }
    },

    // 刷新趋势明细图表
    refreshTrendDetailChart() {
      // 重置筛选条件
      this.currentReason = "";
      // 清空明细数据
      this.refundReasonDetailList = [];
      // 重新获取数据并更新图表
      const params = this.getReq();
      this.getReason(params, 0);
    },

    refreshOrderStatusDetailChart() {
      // 重置筛选条件
      this.currentStatus = "";
      // 清空明细数据
      this.orderStatusDetailList = [];
      // 重新获取数据并更新图表
      const params = this.getReq();
      this.getStatus(params);
    },

    // 销毁图表
    disposeCharts() {
      if (this.refundReasonChart) {
        this.refundReasonChart.dispose();
      }
      if (this.orderStatusChart) {
        this.orderStatusChart.dispose();
      }
      if (this.refundTrendChart) {
        this.refundTrendChart.dispose();
      }
      if (this.refundTrendDetailChart) {
        this.refundTrendDetailChart.dispose();
      }
      if (this.orderStatusDetailChart) {
        this.orderStatusDetailChart.dispose();
      }
    },

    // 快速操作
    exportData() {
      this.downloadTable();
    },

    refreshData() {
      this.handleQuery();
    },

    resetFilters() {
      this.reqForm.storeIdList = [];
      this.category = ["1", "2", "3", "4", "5", "6", "7", "8"];
      this.setRangeDates();
      this.handleQuery();
    },
  },
};
</script>

<style lang="scss" scoped>
.cyberpunk-refund-analysis {
  font-family: "Rajdhani", sans-serif;
  // background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #ffffff;
  min-height: 100vh;
  position: relative;
  overflow-x: hidden;

  /* 数字雨背景效果 */
  .matrix-rain {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    z-index: -3;
    opacity: 0.1;

    canvas {
      width: 100%;
      height: 100%;
    }
  }

  /* 扫描线效果 */
  .scanlines {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    z-index: -2;
    background: repeating-linear-gradient(
      0deg,
      transparent,
      transparent 2px,
      rgba(255, 255, 255, 0.03) 2px,
      rgba(255, 255, 255, 0.03) 4px
    );
    animation: scanlines 0.1s linear infinite;
  }

  @keyframes scanlines {
    0% {
      transform: translateY(0);
    }
    100% {
      transform: translateY(4px);
    }
  }

  /* 全息网格背景 */
  .holo-grid {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: linear-gradient(
        rgba(255, 255, 255, 0.1) 1px,
        transparent 1px
      ),
      linear-gradient(90deg, rgba(255, 255, 255, 0.1) 1px, transparent 1px);
    background-size: 50px 50px;
    animation: gridPulse 4s ease-in-out infinite;
    pointer-events: none;
    z-index: -2;
  }

  @keyframes gridPulse {
    0%,
    100% {
      opacity: 0.1;
    }
    50% {
      opacity: 0.3;
    }
  }

  /* 粒子效果 */
  .particles {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    z-index: -1;
  }

  .particle {
    position: absolute;
    width: 2px;
    height: 2px;
    background: #ffffff;
    border-radius: 50%;
    box-shadow: 0 0 6px #ffffff;
    animation: particleFloat 10s linear infinite;
  }

  @keyframes particleFloat {
    0% {
      transform: translateY(100vh) translateX(0px);
      opacity: 0;
    }
    10% {
      opacity: 1;
    }
    90% {
      opacity: 1;
    }
    100% {
      transform: translateY(-10px) translateX(100px);
      opacity: 0;
    }
  }

  /* 全息导航栏 */
  .holo-nav {
    position: relative;
    margin-bottom: 30px;
    padding: 20px 0;
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.3);
    border-radius: 0 20px 0 20px;
    backdrop-filter: blur(20px);
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.2),
      0 0 50px rgba(255, 255, 255, 0.2);
    animation: holoGlow 3s ease-in-out infinite;
  }

  @keyframes holoGlow {
    0%,
    100% {
      box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.1),
        0 0 30px rgba(0, 242, 255, 0.2);
    }
    50% {
      box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.2),
        0 0 60px rgba(0, 242, 255, 0.4);
    }
  }

  .nav-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 30px;
  }

  .system-title {
    font-family: "Orbitron", monospace;
    font-size: 32px;
    font-weight: 900;
    background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 50%, #e9ecef 100%);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
    text-shadow: 0 0 30px rgba(255, 255, 255, 0.8);
    position: relative;
  }

  .system-title .glitch {
    position: absolute;
    top: 0;
    left: 0;
    background: linear-gradient(135deg, #00f2ff 0%, #7e00ff 50%, #00ffcc 100%);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
    animation: glitch 2s infinite;
  }

  @keyframes glitch {
    0%,
    90%,
    100% {
      transform: translate(0);
    }
    91% {
      transform: translate(-2px, -2px);
    }
    92% {
      transform: translate(2px, 2px);
    }
    93% {
      transform: translate(-2px, 2px);
    }
    94% {
      transform: translate(2px, -2px);
    }
    95% {
      transform: translate(-2px, -2px);
    }
  }

  .system-info {
    display: flex;
    gap: 30px;
    align-items: center;
    font-family: "Orbitron", monospace;
  }

  .status-indicator {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 16px;
    background: rgba(255, 255, 255, 0.2);
    border: 1px solid rgba(255, 255, 255, 0.3);
    border-radius: 20px;
    backdrop-filter: blur(10px);
  }

  .status-dot {
    width: 8px;
    height: 8px;
    background: #ffffff;
    border-radius: 50%;
    box-shadow: 0 0 15px #ffffff;
    animation: pulse 2s ease-in-out infinite;
  }

  @keyframes pulse {
    0%,
    100% {
      opacity: 1;
      transform: scale(1);
    }
    50% {
      opacity: 0.7;
      transform: scale(1.2);
    }
  }

  .real-time {
    font-size: 18px;
    color: #ffffff;
    text-shadow: 0 0 10px #ffffff;
  }

  /* 主要布局 */
  .main-layout {
    display: grid;
    grid-template-columns: 1fr;
    gap: 30px;
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 20px;
  }

  /* 图表区域 */
  .charts-area {
    display: grid;
    gap: 30px;
  }

  /* 玻璃态面板 */
  .glass-panel {
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.3);
    border-radius: 15px;
    backdrop-filter: blur(20px);
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.2),
      0 0 30px rgba(255, 255, 255, 0.1);
    position: relative;
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-3px);
      box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.3),
        0 0 50px rgba(255, 255, 255, 0.2);
    }

    &.full-width {
      grid-column: 1 / -1;
    }
  }

  /* 控制面板 */
  .control-panel {
    padding: 25px;
  }

  .panel-title {
    font-family: "Orbitron", monospace;
    font-size: 16px;
    color: #ffffff;
    margin-bottom: 20px;
    text-align: center;
    text-transform: uppercase;
    letter-spacing: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
  }

  .cyber-icon {
    font-size: 18px;
    animation: float 3s ease-in-out infinite;
  }

  @keyframes float {
    0%,
    100% {
      transform: translateY(0px);
    }
    50% {
      transform: translateY(-5px);
    }
  }

  .control-grid {
    display: grid;
    gap: 10px;
    grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
    justify-items: start;
  }

  .control-item {
    position: relative;
    max-width: 250px;
    width: 100%;
  }

  .control-label {
    display: block;
    font-size: 16px;
    color: #ffffff;
    margin-bottom: 8px;
    text-transform: uppercase;
    letter-spacing: 1px;
    font-weight: 600;
  }

  .cyber-select,
  .cyber-date-picker {
    width: 100%;

    ::v-deep .el-input__inner {
      background: transparent !important; /* remove dark background */
      border: 1px solid rgba(0, 242, 255, 0.4) !important;
      border-radius: 10px !important;
      color: #00f2ff !important;
      font-family: "Rajdhani", sans-serif !important;
      font-size: 14px !important;
      height: 38px !important; /* use Element默认行为，多个tag时框体自动调整 */
      line-height: 38px !important;
      padding: 0 12px !important;
      transition: all 0.3s ease !important;
      backdrop-filter: blur(10px) !important;
    }

    /* tag pill appearance */
    ::v-deep .el-select .el-tag {
      background: rgba(0, 242, 255, 0.18) !important;
      border: 1px solid rgba(0, 242, 255, 0.35) !important;
      color: #e6fbff !important;
      border-radius: 8px !important;
      height: 22px !important;
      line-height: 20px !important;
      margin: 3px 4px 3px 0 !important;
      padding: 0 8px !important;
      font-size: 12px !important;
    }
    ::v-deep .el-select .el-tag {
      background: rgba(0, 242, 255, 0.18) !important;
      border: 1px solid rgba(0, 242, 255, 0.35) !important;
      color: #e6fbff !important;
      border-radius: 8px !important;
      height: 22px !important;
      line-height: 20px !important;
      margin: 3px 4px 3px 0 !important;
      padding: 0 8px !important;
      font-size: 12px !important;
    }
    ::v-deep .el-tag .el-icon-close {
      color: #e6fbff !important;
    }

    ::v-deep .el-select-dropdown {
      background: transparent !important; /* remove dark dropdown background */
      border: 1px solid rgba(0, 242, 255, 0.3) !important;
      backdrop-filter: blur(10px) !important;
      border-radius: 10px !important;
    }
    /* dropdown list max height and scrolling */
    ::v-deep .el-select-dropdown .el-scrollbar__wrap {
      max-height: 320px !important;
    }

    ::v-deep .el-option {
      background: transparent !important;
      color: #00f2ff !important;

      &:hover {
        background: rgba(0, 242, 255, 0.2) !important;
      }

      &.selected {
        background: rgba(0, 242, 255, 0.3) !important;
        color: #ffffff !important;
      }
    }
  }

  /* 恢复筛选框宽度为之前的布局（填满栅格列） */
  .control-item .mineSelect {
    width: 100% !important;
  }

  .cyber-button {
    width: 100%;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border: none;
    border-radius: 8px;
    padding: 12px 20px;
    color: #ffffff;
    font-family: "Orbitron", monospace;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    text-transform: uppercase;
    letter-spacing: 1px;
    position: relative;
    overflow: hidden;

    .button-text {
      position: relative;
      z-index: 2;
    }

    .button-glow {
      position: absolute;
      top: 0;
      left: -100%;
      width: 100%;
      height: 100%;
      background: linear-gradient(
        90deg,
        transparent,
        rgba(255, 255, 255, 0.2),
        transparent
      );
      transition: left 0.5s;
    }

    &:hover .button-glow {
      left: 100%;
    }

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 10px 30px rgba(102, 126, 234, 0.4);
    }
  }

  .cyber-button-small {
    background: rgba(255, 255, 255, 0.2);
    border: 1px solid rgba(255, 255, 255, 0.3);
    color: #ffffff;
    padding: 8px 12px;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.3s ease;
    font-family: "Orbitron", monospace;
    font-size: 12px;

    &:hover {
      background: #ffffff;
      color: #667eea;
      box-shadow: 0 0 15px rgba(255, 255, 255, 0.5);
    }
  }

  /* 图表容器 */
  .chart-container {
    padding: 25px;
  }

  .chart-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding-bottom: 15px;
    border-bottom: 1px solid rgba(0, 242, 255, 0.2);
  }

  .chart-controls {
    display: flex;
    gap: 10px;
  }

  .chart-title {
    font-family: "Orbitron", monospace;
    font-size: 18px;
    color: #ffffff;
    margin: 0;
    text-transform: uppercase;
    letter-spacing: 2px;
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .chart-content {
    height: 300px;
    position: relative;
  }

  .ranking-chart {
    height: 400px;
  }

  /* 统计卡片行 */
  .stats-row {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 20px;
    margin-bottom: 30px;
  }

  /* 右侧信息面板 */
  .info-panel {
    display: grid;
    gap: 20px;
    align-content: start;
  }

  /* 统计卡片 */
  .stat-card {
    padding: 20px;
    position: relative;
    overflow: hidden;

    .stat-glow {
      position: absolute;
      top: -2px;
      left: -2px;
      right: -2px;
      bottom: -2px;
      background: linear-gradient(45deg, #7e00ff, #00f2ff, #00ffcc, #7e00ff);
      border-radius: 15px;
      opacity: 0;
      animation: borderGlow 4s linear infinite;
      z-index: -1;
    }

    @keyframes borderGlow {
      0%,
      100% {
        opacity: 0;
      }
      50% {
        opacity: 0.8;
      }
    }

    &.primary .stat-glow {
      background: linear-gradient(45deg, #00f2ff, #0077b6, #00f2ff);
    }

    &.warning .stat-glow {
      background: linear-gradient(45deg, #ffc107, #ff9500, #ffc107);
    }

    &.danger .stat-glow {
      background: linear-gradient(45deg, #dc3545, #d32f2f, #dc3545);
    }

    &.success .stat-glow {
      background: linear-gradient(45deg, #28a745, #00b894, #28a745);
    }
  }

  .stat-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
  }

  .stat-title {
    font-family: "Orbitron", monospace;
    font-size: 14px;
    color: #ffffff;
    text-transform: uppercase;
    letter-spacing: 1px;
  }

  .stat-icon {
    font-size: 24px;
    opacity: 0.7;
    animation: float 3s ease-in-out infinite;
  }

  .stat-value {
    font-family: "Orbitron", monospace;
    font-size: 28px;
    font-weight: 900;
    color: #ffffff;
    text-shadow: 0 0 15px rgba(255, 255, 255, 0.8);
    margin-bottom: 10px;
    animation: countUp 1s ease-out;
  }

  @keyframes countUp {
    from {
      opacity: 0;
      transform: scale(0.8);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }

  .stat-trend {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 12px;
    color: #ffffff;
    opacity: 0.8;
  }

  /* 系统状态 */
  .system-metrics {
    display: grid;
    gap: 15px;
  }

  .metric {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .metric-label {
    font-size: 12px;
    color: #ffffff;
    min-width: 60px;
  }

  .metric-value {
    font-family: "Orbitron", monospace;
    font-size: 14px;
    color: #ffffff;
    min-width: 40px;
    text-align: right;

    &.status-online {
      color: #ffffff;
    }
  }

  .metric-bar {
    flex: 1;
    height: 4px;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 2px;
    overflow: hidden;
  }

  .metric-fill {
    height: 100%;
    background: linear-gradient(90deg, #ffffff, #f8f9fa);
    border-radius: 2px;
    transition: width 1s ease;
  }

  /* 快速操作 */
  .action-buttons {
    display: grid;
    gap: 10px;
  }

  /* 数据表格 */
  .data-table {
    padding: 25px;
  }

  .table-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding-bottom: 15px;
    border-bottom: 1px solid rgba(0, 242, 255, 0.2);
  }

  .table-container {
    overflow: hidden;
    border-radius: 0;
    // 在窄屏幕下启用水平滚动
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  // 表格响应式优化
  @media (max-width: 768px) {
    .table-container {
      .el-table {
        min-width: 800px; // 确保表格最小宽度
      }
    }
  }

  /* 退款率条形图样式 */
  .bar-cell {
    position: relative;
    width: 100%;
    height: 24px;
    background: rgba(255, 255, 255, 0.05);
    border-radius: 12px;
    overflow: hidden;
  }

  .bar-fill {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    border-radius: 12px;
    transition: width 0.6s ease;
  }

  .bar-text {
    position: absolute;
    right: 12px;
    top: 0;
    height: 100%;
    display: flex;
    align-items: center;
    font-weight: 700;
    font-size: 13px;
    color: #fff;
    z-index: 2;
  }

  .rate .bar-rate {
    background: linear-gradient(90deg, #fa709a, #fee140);
  }

  .rate-value {
    font-family: "Orbitron", monospace;
    font-weight: 600;
    color: #ffffff;
  }

  /* 分页器 */
  .pagination-container {
    margin-top: 20px;
    text-align: center;
  }
  ::v-deep .el-pagination__total {
    color: #ffffff;
  }
  .cyber-pagination {
    ::v-deep .el-pagination__jump {
      color: #ffffff !important;
    }
    ::v-deep .el-pagination {
      .el-pagination__total {
        color: #ffffff !important;
      }

      .el-pagination__sizes {
        .el-select .el-input__inner {
          background: rgba(255, 255, 255, 0.1) !important;
          border: 1px solid rgba(0, 242, 255, 0.3) !important;
          color: #ffffff !important;
        }
      }

      .btn-prev,
      .btn-next {
        background: rgba(255, 255, 255, 0.2) !important;
        border: 1px solid rgba(255, 255, 255, 0.3) !important;
        color: #ffffff !important;

        &:hover {
          background: #ffffff !important;
          color: #667eea !important;
        }
      }

      .el-pager li {
        background: rgba(255, 255, 255, 0.1) !important;
        border: 1px solid rgba(255, 255, 255, 0.3) !important;
        color: #ffffff !important;

        &:hover {
          background: rgba(255, 255, 255, 0.2) !important;
        }

        &.active {
          background: #ffffff !important;
          color: #667eea !important;
        }
      }
    }
  }

  /* 响应式设计 */
  @media (max-width: 1200px) {
    .main-layout {
      grid-template-columns: 1fr;
      gap: 20px;
    }

    .info-panel {
      grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    }
  }

  @media (max-width: 992px) {
    .dual-reason,
    .dual-status {
      grid-template-columns: 1fr;
      gap: 0;

      > .chart-container:first-child {
        border-right: none;
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
      }

      > .chart-container:first-child .chart-content {
        height: 300px;
      }

      > .chart-container:last-child .chart-content {
        height: 300px;
      }
    }
  }

  @media (max-width: 768px) {
    padding: 10px;

    .nav-content {
      padding: 0 15px;
      flex-direction: column;
      gap: 15px;
    }

    .system-title {
      font-size: 24px;
    }

    .chart-content,
    .ranking-chart {
      height: 250px;
    }

    .control-grid {
      grid-template-columns: 1fr;
    }

    .stats-row {
      grid-template-columns: 1fr;
      gap: 15px;
    }

    .chart-header {
      flex-direction: column;
      align-items: flex-start;
      gap: 10px;
    }

    .chart-controls {
      width: 100%;
      justify-content: flex-end;
    }

    .dual-reason,
    .dual-status {
      > .chart-container:first-child .chart-content {
        height: 250px;
      }

      > .chart-container:last-child .chart-content {
        height: 250px;
      }
    }
  }

  @media (max-width: 480px) {
    .main-layout {
      padding: 0 10px;
    }

    .control-panel {
      padding: 15px;
    }

    .chart-container {
      padding: 15px;
    }

    .chart-content,
    .ranking-chart {
      height: 200px;
    }

    .dual-reason,
    .dual-status {
      > .chart-container:first-child .chart-content {
        height: 200px;
      }

      > .chart-container:last-child .chart-content {
        height: 200px;
      }
    }

    .stat-card {
      padding: 15px;
    }

    .stat-value {
      font-size: 24px;
    }

    .chart-title {
      font-size: 16px;
    }

    .cyber-button {
      width: 100%;
      max-width: 300px;
    }
  }
}

.reason-list {
  max-height: none;
  overflow: visible;

  .reason-item {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 10px;
    padding: 6px 0;
    font-size: 14px;
    border-bottom: 1px dashed rgba(255, 255, 255, 0.12);
    flex-wrap: wrap; /* allow sub-status to break to a new line */

    .reason-name {
      flex: 1 1 auto;
      min-width: 0;
      color: #ffffff;
      font-weight: 600;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .reason-count,
    .reason-rate {
      flex: 0 0 auto;
      min-width: 70px;
      text-align: right;
    }
    .reason-count {
      color: #00f2ff;
      font-weight: 700;
    }
    .reason-rate {
      color: #ffd98f;
      font-weight: 600;
    }
    /* make the sub-status occupy full width below the header row */
    .sub-status {
      flex: 0 0 100%;
      width: 100%;
    }
  }
}

.dual-reason {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 0;
  align-items: stretch; /* match heights */
  width: 100%;
  box-sizing: border-box;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 15px;
  overflow: hidden;
  backdrop-filter: blur(10px);

  > .chart-container {
    min-width: 0; /* allow shrink */
    width: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column; /* header + content */
    background: transparent;
    border: none;
    border-radius: 0;
    backdrop-filter: none;

    &:first-child {
      border-right: 1px solid rgba(255, 255, 255, 0.1);
    }
  }

  /* Ensure sufficient height for the pie chart to avoid overlapping */
  > .chart-container:first-child .chart-content {
    height: 360px;
    margin-bottom: 8px;
  }

  /* Set height for the detail chart to match the pie chart */
  > .chart-container:last-child .chart-content {
    height: 360px;
    margin-bottom: 8px;
  }

  @media (max-width: 992px) {
    grid-template-columns: 1fr;
    gap: 0;

    > .chart-container:first-child {
      border-right: none;
      border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    }

    /* On small screens, slightly reduce chart height to fit viewport */
    > .chart-container:first-child .chart-content {
      height: 300px;
    }
  }
}

.dual-status {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 0;
  align-items: stretch; /* match heights */
  width: 100%;
  box-sizing: border-box;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 15px;
  overflow: hidden;
  backdrop-filter: blur(10px);
  margin-top: 24px;

  > .chart-container {
    min-width: 0; /* allow shrink */
    width: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column; /* header + content */
    background: transparent;
    border: none;
    border-radius: 0;
    backdrop-filter: none;

    &:first-child {
      border-right: 1px solid rgba(255, 255, 255, 0.1);
    }
  }

  /* Ensure sufficient height for the pie chart to avoid overlapping */
  > .chart-container:first-child .chart-content {
    height: 360px;
    margin-bottom: 8px;
  }

  /* Set height for the detail chart to match the pie chart */
  > .chart-container:last-child .chart-content {
    height: 360px;
    margin-bottom: 8px;
  }

  @media (max-width: 992px) {
    grid-template-columns: 1fr;
    gap: 0;

    > .chart-container:first-child {
      border-right: none;
      border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    }

    /* On small screens, slightly reduce chart height to fit viewport */
    > .chart-container:first-child .chart-content {
      height: 300px;
    }

    /* Set height for the detail chart on mobile */
    > .chart-container:last-child .chart-content {
      height: 300px;
    }
  }
}

/* Make inner content grow to equal heights and prevent overflow */
.dual-reason .chart-container .chart-content,
.dual-reason .chart-container .reason-list-wrapper {
  flex: 1 1 auto;
  min-height: 0;
}
.reason-list-wrapper {
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.reason-list-wrapper .reason-list {
  overflow: auto;
  min-width: 0;
  scrollbar-width: thin;
  scrollbar-color: #58d9f9 transparent;
}
.reason-list-wrapper .reason-list::-webkit-scrollbar {
  background-color: transparent;
  width: 10px;
  border: 1px solid;
  border-radius: 5px;
}
.reason-list-wrapper .reason-list::-webkit-scrollbar-thumb {
  background-color: #58d9f9;
  border-radius: 5px;
}
.reason-list-wrapper .reason-list::-webkit-scrollbar-thumb:hover {
  background-color: #7cffb2;
}
.reason-list-wrapper .reason-list::-webkit-scrollbar-track {
  background-color: transparent;
  border-radius: 5px;
}

.chart-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.chart-header .chart-title {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.chart-header .cyber-button-small {
  flex: 0 0 auto;
}

.chart-hint {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  margin: 8px 0;
  background: rgba(88, 217, 249, 0.1);
  border: 1px solid rgba(88, 217, 249, 0.3);
  border-radius: 6px;
  font-size: 14px;
  color: #fff;
  animation: hintPulse 2s ease-in-out infinite;
}

.hint-icon {
  font-size: 14px;
  animation: hintGlow 1.5s ease-in-out infinite alternate;
}

.hint-text {
  flex: 1;
  line-height: 1.4;
}

@keyframes hintPulse {
  0%,
  100% {
    opacity: 0.8;
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(1.02);
  }
}

@keyframes hintGlow {
  0% {
    text-shadow: 0 0 5px #58d9f9;
  }
  100% {
    text-shadow: 0 0 10px #58d9f9, 0 0 20px #58d9f9;
  }
}

.sub-status {
  margin-top: 10px;
  padding: 12px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 8px;
}
.sub-groups {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.sub-group {
  flex: 1 1 calc(33% - 10px);
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 5px;
  padding: 10px;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 10px 20px rgba(255, 255, 255, 0.2);
  }
}
.group-header {
  font-weight: 700;
  color: #00f2ff;
  margin-bottom: 5px;
}
.group-body {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.status-count,
.status-rate {
  font-size: 14px;
  color: #ffffff;
}

/* 展开式未出货状态分组样式（横向展示，避免整体增高） */
.sub-status {
  margin-top: 6px;
  padding: 8px 8px 4px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 8px;
}
.sub-title {
  font-weight: 700;
  color: #00f2ff;
  margin: 2px 0 6px;
  font-size: 12px;
}
/* 横向滚动容器：单行不换行，超出横向滚动 */
.sub-groups {
  display: flex;
  flex-wrap: nowrap;
  gap: 8px;
  overflow-x: auto;
  overflow-y: hidden;
  padding-bottom: 4px;
  -webkit-overflow-scrolling: touch;
}
.sub-groups::-webkit-scrollbar {
  background-color: transparent;
  height: 10px;
  border: 1px solid;
  border-radius: 5px;
}
.sub-groups::-webkit-scrollbar-track {
  background-color: transparent;
  border-radius: 5px;
}
.sub-groups::-webkit-scrollbar-thumb {
  background-color: #58d9f9;
  border-radius: 5px;
}
.sub-groups::-webkit-scrollbar-thumb:hover {
  background-color: #7cffb2;
}
/* 子卡片固定最小宽度，避免撑高；横向排列 */
.sub-group {
  flex: 0 0 auto;
  min-width: 120px;
  background: rgba(255, 255, 255, 0.06);
}

/* 全局滚动条样式 - 匹配销售走势图风格 */
.cyberpunk-refund-analysis::-webkit-scrollbar {
  background-color: transparent;
  width: 10px;
  border: 1px solid;
  border-radius: 5px;
}

.cyberpunk-refund-analysis::-webkit-scrollbar-thumb {
  background-color: #58d9f9;
  border-radius: 5px;
}

.cyberpunk-refund-analysis::-webkit-scrollbar-thumb:hover {
  background-color: #7cffb2;
}

.cyberpunk-refund-analysis::-webkit-scrollbar-track {
  background-color: transparent;
  border-radius: 5px;
}

/* 表格滚动条样式 */
.cyber-table::-webkit-scrollbar {
  background-color: transparent;
  width: 10px;
  height: 10px;
  border: 1px solid;
  border-radius: 5px;
}

.cyber-table::-webkit-scrollbar-thumb {
  background-color: #58d9f9;
  border-radius: 5px;
}

.cyber-table::-webkit-scrollbar-thumb:hover {
  background-color: #7cffb2;
}

.cyber-table::-webkit-scrollbar-track {
  background-color: transparent;
  border-radius: 5px;
}
.group-header {
  font-weight: 700;
  color: #fff;
  margin-bottom: 4px;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.group-body {
  display: inline-flex;
  gap: 10px;
  align-items: center;
  white-space: nowrap;
}
.group-body .status-count {
  color: #00f2ff;
  font-weight: 700;
}
.group-body .status-rate {
  color: #ffd98f;
  font-weight: 600;
}

/* 按钮图标样式 */
.cyber-button i.iconfont,
.cyber-button-small i.iconfont {
  margin-right: 6px;
  color: #00ffff;
  font-size: 14px;
  transition: all 0.3s ease;
}

.cyber-button:hover i.iconfont,
.cyber-button-small:hover i.iconfont {
  color: #ff00ff;
  transform: scale(1.1);
}

/* 主按钮的图标稍大一些 */
.cyber-button i.iconfont {
  font-size: 16px;
  margin-right: 8px;
}

/* 订单状态明细列表样式 */
.status-detail-list {
  max-height: 400px;
  overflow-y: scroll; /* 与退款原因明细一致 */
  padding: 10px 0 24px; /* 增加底部padding确保最后一条数据可见 */
  scroll-behavior: smooth;
  box-sizing: border-box;
}

/* 响应式优化 - 移动端明细列表 */
@media (max-width: 768px) {
  .status-detail-list,
  .reason-detail-list {
    max-height: 300px;
    padding: 8px 0 16px;
  }

  .status-detail-item,
  .reason-detail-item {
    padding: 12px;
    margin-bottom: 8px;
    flex-direction: column;
    align-items: flex-start;
  }

  .rank-badge,
  .reason-rank-badge {
    width: 40px;
    height: 20px;
    font-size: 10px;
    margin-right: 12px;
    margin-bottom: 8px;
  }

  .item-content,
  .reason-item-content {
    width: 100%;
    margin-right: 0;
    margin-bottom: 8px;
  }

  .device-name,
  .reason-device-name {
    font-size: 13px;
    margin-bottom: 6px;
  }

  .progress-bar-container,
  .reason-progress-bar-container {
    height: 10px;
  }

  .status-count,
  .reason-count {
    font-size: 12px;
    text-align: left;
    margin-top: 0;
  }
}

.status-detail-item {
  display: flex;
  align-items: flex-start;
  padding: 16px;
  margin-bottom: 12px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  transition: all 0.3s ease;
}

.status-detail-item:hover {
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(0, 255, 255, 0.3);
  box-shadow: 0 2px 10px rgba(0, 255, 255, 0.15); /* 用阴影替代transform */
}

.status-detail-item:last-child {
  margin-bottom: 0; /* 最后一项不需要底部margin */
}

.rank-badge {
  width: 50px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  font-size: 12px;
  font-weight: bold;
  margin-right: 16px;
  flex-shrink: 0;
}

.rank-1 {
  background: linear-gradient(45deg, #ffd700, #ffed4e);
  color: #000;
  border: 2px solid #ffd700;
}

.rank-2 {
  background: linear-gradient(45deg, #c0c0c0, #e5e5e5);
  color: #000;
  border: 2px solid #c0c0c0;
}

.rank-3 {
  background: linear-gradient(45deg, #cd7f32, #daa520);
  color: #fff;
  border: 2px solid #cd7f32;
}

.rank-4-50 {
  background: linear-gradient(45deg, #6c757d, #8e9aaf);
  color: #fff;
  border: 2px solid #6c757d;
}

.rank-50-plus {
  background: linear-gradient(45deg, #495057, #6c757d);
  color: #fff;
  border: 2px solid #495057;
}

.rank-placeholder {
  width: 50px;
  margin-right: 16px;
  flex-shrink: 0;
}

.item-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  margin-right: 16px;
}

.device-name {
  color: #ffffff;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.progress-bar-container {
  height: 12px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 6px;
  overflow: hidden;
  position: relative;
}

.progress-bar {
  height: 100%;
  background: linear-gradient(90deg, #00ffff, #58d9f9, #7cffb2);
  border-radius: 6px;
  transition: width 0.8s ease;
  position: relative;
  box-shadow: 0 0 10px rgba(0, 255, 255, 0.5);
}

.progress-bar::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  width: 4px;
  height: 100%;
  background: #ffffff;
  border-radius: 2px;
  box-shadow: 0 0 8px rgba(255, 255, 255, 0.8);
}

.status-count {
  color: #ffffff;
  font-size: 14px;
  font-weight: bold;
  min-width: 60px;
  text-align: right;
  text-shadow: 0 0 5px rgba(255, 255, 255, 0.5);
  margin-top: 2px;
}

/* 自定义滚动条 - 使用更具体的选择器 */
.chart-content .status-detail-list::-webkit-scrollbar {
  width: 12px !important;
}

.chart-content .status-detail-list::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.2) !important;
  border-radius: 6px !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
}

.chart-content .status-detail-list::-webkit-scrollbar-thumb {
  background: linear-gradient(180deg, #00ffff, #58d9f9) !important;
  border-radius: 6px !important;
  border: 2px solid rgba(255, 255, 255, 0.4) !important;
  min-height: 30px !important;
}

.chart-content .status-detail-list::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(180deg, #58d9f9, #7cffb2) !important;
  border-color: rgba(255, 255, 255, 0.6) !important;
}

.chart-content .status-detail-list::-webkit-scrollbar-corner {
  background: rgba(255, 255, 255, 0.2) !important;
}

/* 退款原因明细列表样式 */
.reason-detail-list {
  max-height: 400px;
  overflow-y: scroll; /* 强制滚动条始终可见 */
  padding: 10px 0 24px; /* 增加底部padding确保最后一条数据可见 */
  scroll-behavior: smooth;
  box-sizing: border-box;
  position: relative; /* 添加相对定位 */
  /* 移除Firefox滚动条属性，避免与WebKit冲突 */
  /* scrollbar-width: thin; */
  /* scrollbar-color: #ff6b9d rgba(255, 255, 255, 0.1); */
}

/* 退款原因列表自定义滚动条 - 使用更具体的选择器 */
.chart-content .reason-detail-list::-webkit-scrollbar {
  width: 12px !important;
  height: 12px !important;
}

.chart-content .reason-detail-list::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.2) !important;
  border-radius: 6px !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
  margin: 2px !important;
  position: relative !important;
  /* 强制滑轨不超出容器范围 */
  box-sizing: border-box !important;
  overflow: hidden !important;
}

.chart-content .reason-detail-list::-webkit-scrollbar-thumb {
  background: linear-gradient(180deg, #ff6b9d, #ff8fab) !important;
  border-radius: 6px !important;
  border: 2px solid rgba(255, 255, 255, 0.4) !important;
  min-height: 30px !important;
  max-height: calc(100% - 4px) !important;
  position: relative !important;
  /* 强制滑块不超出滑轨范围 */
  box-sizing: border-box !important;
  overflow: hidden !important;
}

.chart-content .reason-detail-list::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(180deg, #ff8fab, #fed6e3) !important;
  border-color: rgba(255, 255, 255, 0.6) !important;
}

.chart-content .reason-detail-list::-webkit-scrollbar-corner {
  background: rgba(255, 255, 255, 0.2) !important;
}

.reason-detail-item {
  display: flex;
  align-items: flex-start;
  padding: 16px;
  margin-bottom: 12px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  transition: background 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease; /* 避免宽度变化 */
}

.reason-detail-item:hover {
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 105, 180, 0.3);
  box-shadow: 0 2px 10px rgba(255, 105, 180, 0.15); /* 用阴影替代transform */
}

.reason-detail-item:last-child {
  margin-bottom: 0; /* 最后一项不需要底部margin */
}

.reason-rank-badge {
  width: 50px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  font-size: 12px;
  font-weight: bold;
  margin-right: 16px;
  flex-shrink: 0;
}

.reason-rank-1 {
  background: linear-gradient(45deg, #ff6b9d, #ff8fab);
  color: #fff;
  border: 2px solid #ff6b9d;
}

.reason-rank-2 {
  background: linear-gradient(45deg, #ff9a9e, #fecfef);
  color: #fff;
  border: 2px solid #ff9a9e;
}

.reason-rank-3 {
  background: linear-gradient(45deg, #a8edea, #fed6e3);
  color: #000;
  border: 2px solid #a8edea;
}

.reason-rank-4-50 {
  background: linear-gradient(45deg, #6c757d, #8e9aaf);
  color: #fff;
  border: 2px solid #6c757d;
}

.reason-rank-50-plus {
  background: linear-gradient(45deg, #495057, #6c757d);
  color: #fff;
  border: 2px solid #495057;
}

.reason-rank-placeholder {
  width: 50px;
  margin-right: 16px;
  flex-shrink: 0;
}

.reason-item-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  margin-right: 16px;
}

.reason-device-name {
  color: #ffffff;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.reason-progress-bar-container {
  height: 12px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 6px;
  overflow: hidden;
  position: relative;
}

.reason-progress-bar {
  height: 100%;
  background: linear-gradient(90deg, #ff6b9d, #ff8fab, #fed6e3);
  border-radius: 6px;
  transition: width 0.8s ease;
  position: relative;
  box-shadow: 0 0 10px rgba(255, 107, 157, 0.5);
}

.reason-progress-bar::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  width: 4px;
  height: 100%;
  background: #ffffff;
  border-radius: 2px;
  box-shadow: 0 0 8px rgba(255, 255, 255, 0.8);
}

.reason-count {
  color: #ffffff;
  font-size: 14px;
  font-weight: bold;
  min-width: 60px;
  text-align: right;
  text-shadow: 0 0 5px rgba(255, 255, 255, 0.5);
  margin-top: 2px;
}
</style>

<style>
.data-table .el-table {
  background: transparent !important;
  color: #fff;
  font-size: 16px;
}

.data-table .el-table tr {
  background: transparent;
}

.data-table .el-table th.el-table__cell {
  background: transparent !important;
  color: #fff;
}

/* 排序图标颜色 */
.data-table .el-table .caret-wrapper {
  color: #ffffff !important;
}

.data-table .el-table .sort-caret.ascending {
  border-bottom-color: #ffffff !important;
}

.data-table .el-table .sort-caret.descending {
  border-top-color: #ffffff !important;
}

/* 排序激活状态的颜色 */
.data-table .el-table th.is-sortable.ascending .caret-wrapper {
  color: #ff4757 !important;
}

.data-table .el-table th.is-sortable.descending .caret-wrapper {
  color: #ff4757 !important;
}

/* 确保激活状态的排序箭头颜色 */
.data-table .el-table th.is-sortable.ascending .sort-caret.ascending {
  border-bottom-color: #ff4757 !important;
}

.data-table .el-table th.is-sortable.descending .sort-caret.descending {
  border-top-color: #ff4757 !important;
}

/* 表格行hover样式 */
.data-table
  .el-table--enable-row-hover
  .el-table__body
  tr:hover
  > td.el-table__cell {
  background-color: rgba(88, 217, 249, 0.2) !important;
  color: #ffffff !important;
  font-weight: bold;
  border: 1px solid rgba(88, 217, 249, 0.4) !important;
}
</style>
